<template>
  <div class="m-page-main" v-if="banner && banner.visible == 1">
    <div class="c-banner">
      <a-carousel arrows :autoplay="true">
        <div
          slot="prevArrow"
          class="custom-slick-arrow"
          style="left: 10px; zIndex: 1"
        >
          <a-icon type="left-circle" />
        </div>
        <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">
          <a-icon type="right-circle" />
        </div>
        <div
          v-for="item in banner.bannerList"
          :key="item.bannerUrl"
          class="banner-swipe-item"
        >
          <a
            :href="item.linkUrl || 'javascript:;'"
            :target="item.linkUrl ? '_blank' : ''"
          >
            <img :src="item.bannerUrl || './images/banner.jpg'" alt="" />
          </a>
        </div>
      </a-carousel>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
  data() {
    return {
      banner: {
        visible: 0,
        bannerList: []
      }
    };
  },
  created() {
    this.banner = this.$store.getters.getterTempConfig.bannerConfig;
  },
  computed: {
    tempConfig() {
      return this.$store.getters.getterTempConfig;
    }
  },
  watch: {
    tempConfig(val) {
      this.banner = val.bannerConfig;
    }
  }
};
</script>
